import type { LotState, SaleState } from '@bia-auction/shared-schema';

import type { BadgeProps } from '../components/badge';

type StatusVariant = NonNullable<BadgeProps['variant']>;

/**
 * Auction-state → badge-variant mapping (docs/15-ui-design-system.md §6 — our
 * adaptation of the kit's fleet pipeline colors). Color never carries the state
 * alone: callers must pair the badge with the i18n'd state label.
 */
export function saleStatusVariant(state: SaleState): StatusVariant {
  switch (state) {
    case 'DRAFT':
      return 'neutral';
    case 'PUBLISHED':
      return 'info';
    case 'LIVE':
      return 'live';
    case 'PAUSED':
      return 'warning';
    case 'CLOSED':
      return 'success';
    case 'CANCELLED':
      return 'destructive';
  }
}

/** Lot-state → badge-variant mapping (docs/15 §6). */
export function lotStatusVariant(state: LotState): StatusVariant {
  switch (state) {
    case 'SCHEDULED':
      return 'info';
    case 'OPEN':
      return 'live';
    case 'SOLD':
      return 'success';
    case 'UNSOLD':
      return 'neutral';
    case 'REMOVED':
      return 'destructive';
  }
}
